import { StoreAikaState } from "./state";

export default {
    getCategories(state: StoreAikaState) {
        return state.categories;
    },
    getFilteredProducts(state: StoreAikaState) {
        return state.filteredProducts;
    }
};